// TODO: use variables for the colours

export const Branding: Map<string, Map<string, string>> = new Map<string, Map<string, string>>([
    [
        "inovus",
        new Map<string, string>([
            ["--brand-accent", "#000000"],
            ["--sidebar-background", "#121318"],
            ["app-title", "Totum"],
            ["login-logo-scale", "0.4"],
            ["main-page-logo-scale", "0.6"],
            ["video-background", "https://inovus-public-assets.s3.eu-west-2.amazonaws.com/web/TotumVideo.mp4"],
        ]),
    ],

    [
        "hologic",
        new Map<string, string>([
            ["--brand-accent", "#151F6D"],
            ["--sidebar-background", "#202b7d"],
            ["app-title", "Totum"],
            ["login-logo-scale", "1.4"],
            ["main-page-logo-scale", "0.9"],
            ["video-background", "https://inovus-public-assets.s3.eu-west-2.amazonaws.com/web/HologicVideo.mp4"],
        ]),
    ],

    [
        "medtronic",
        new Map<string, string>([
            ["--brand-accent", "#130c4b"],
            ["--sidebar-background", "#1b125c"],
            ["app-title", "Totum"],
            ["login-logo-scale", "1.5"],
            ["video-background", "https://inovus-public-assets.s3.eu-west-2.amazonaws.com/web/MedtronicVideo.mp4"],
        ]),
    ],
]);

/**
 * Fetch a variable specific to the branding configuration from environment variables.
 * @param variableName
 */
export const getBranding = (variableName: string) => {
    // TODO: add this when using strict @ts-expect-error - The branding variable is set in the window object.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return Branding.get(window["branding"])?.get(variableName);
};
